<template>
    <v-modal title="Issue" size="large" @close="$emit('close')">
        <div slot="contents">
            <div class="modal-content">
                <div class="grid-item grid-item-full">
                    <h3 class="stack-m">Issue Date</h3>
                    <div class="grid-fitted align-items-center stack-m">
                        <div class="grid-item grid-item-full">
                            <v-radio
                                label="Immediately"
                                :value="true"
                                group="reissueDateGroup"
                                :model="issueImmediately"
                                @update="updateIssueImmediately"
                            />
                        </div>
                    </div>
                    <div class="grid-fitted">
                        <div class="grid-item no-flex display-flex align-items-center">
                            <v-radio
                                class="inline-m"
                                label="Select Date"
                                :value="false"
                                group="reissueDateGroup"
                                :model="issueImmediately"
                                @update="updateIssueImmediately"
                            />
                        </div>
                        <div class="grid-item">
                            <v-date-input
                                type="datetime"
                                v-model="issueTime"
                                :disabled="issueImmediately"
                                :available-dates='availableIssueDates'
                            />
                        </div>
                    </div>
                </div>
                <div class="grid-item grid-item-full margin-top-m">
                    <h3 class="stack-m">Due Date</h3>
                    <div class="grid-fitted">
                        <div class="grid-item">
                            <v-date-input
                                type="datetime"
                                v-model="dueTime"
                                :available-dates='availableDueDates'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template slot="actions">
            <r-button
                type="primary"
                @click="issue">Issue</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vRadio, vDateInput,
    } from '@/components/form';

    export default {
        components: {
            vModal,
            vRadio,
            vDateInput,
        },
        computed: {
            availableIssueDates() {
                return {
                    start: this.getImmediateTime(),
                    end: null,
                };
            },
            availableDueDates() {
                return {
                    start: this.issueTime,
                    end: null,
                };
            },
        },
        watch: {
            issueImmediately() {
                this.updateDueTime();
            },
            issueTime() {
                this.updateDueTime();
            },
        },
        data() {
            return {
                issueImmediately: true,
                issueTime: this.getImmediateTime(),
                dueTime: this.getImmediateTime(),
            };
        },
        methods: {
            issue() {
                if (this.issueImmediately) {
                    this.issueTime = this.getImmediateTime();
                }
                const payload = {
                    issuedTime: this.issueImmediately ? this.getImmediateTime().format() : this.issueTime.format(),
                    dueTime: this.dueTime.format(),
                };
                this.$emit('issue-invoice', payload);
                this.$emit('close');
            },
            updateIssueImmediately(value) {
                this.issueImmediately = value;
            },
            updateDueTime() {
                if (this.issueImmediately) {
                    this.dueTime = this.getImmediateTime();
                } else {
                    this.dueTime = this.issueTime.clone();
                }
            },
            getImmediateTime() {
                return this.$tz().now();
            },
        },
    };
</script>
